import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { getLstFeeStudentSvc } from "./feeStudentSvc";
import { getHpcListSvc } from "./hpcStudentSvc";


const student = {
  schoolInfo: {
    school: "Sunrise Public School",
    address: "123 Elm Street",
    pin: "560001",
    UDISE: "123456789",
    APAARID: "APAARI001",
    teacherCode: "TCH001",
  },
  partA1: {
    studentId: "S001",
    generalInfo: {
      student: 'studentName',
      rollNo: "123",
      enrollmentNo: "ENR123",
      cls: "10",
      section: "A",
      dob: "2005-05-15",
      age: 10,
      address: "456 Maple Avenue",
      phone: "9876543210",
      photo: "path/to/photo.jpg",
      motherInfo: {
        parentId: "P001",
        parent: "Jane Doe",
        education: "Graduate",
        occupation: "Teacher",
      },
      fatherInfo: {
        parentId: "P002",
        parent: "John Sr.",
        education: "Postgraduate",
        occupation: "Engineer",
      },
      guardianInfo: {
        parentId: "P003",
        parent: "Uncle Sam",
        education: "High School",
        occupation: "Farmer",
      },
      noOfSiblings: 2,
      siblingsAge: [8, 12],
      motherTongue: "English",
      instructionMedium: "English",
      flgRuralUrban: "Urban",
    },
    attendanceInfo: {
      lstAttendance: [
        { monthId: 1, month: "Apr", workingDays: 22, daysAttended: 20, pctAttendance: "90%" },
        { monthId: 2, month: "May", workingDays: 20, daysAttended: 18, pctAttendance: "90%" },
        { monthId: 3, month: "Jun", workingDays: "", daysAttended: "", pctAttendance: "" },
        { monthId: 4, month: "Jul", workingDays: "", daysAttended: "", pctAttendance: "" },
        { monthId: 5, month: "Aug", workingDays: "", daysAttended: "", pctAttendance: "" },
        { monthId: 6, month: "Sep", workingDays: "", daysAttended: "", pctAttendance: "" },
        { monthId: 7, month: "Oct", workingDays: "", daysAttended: "", pctAttendance: "" },
        { monthId: 8, month: "Nov", workingDays: "", daysAttended: "", pctAttendance: "" },
        { monthId: 9, month: "Dec", workingDays: "", daysAttended: "", pctAttendance: "" },
        { monthId: 10, month: "Jan", workingDays: "", daysAttended: "", pctAttendance: "" },
        { monthId: 11, month: "Feb", workingDays: "", daysAttended: "", pctAttendance: "" },
        { monthId: 12, month: "Mar", workingDays: "", daysAttended: "", pctAttendance: "" },
      ],
      lowAttendanceReason: "Medical reasons",
    },
    lstInterest: [
      { interestId: 1, interest: "Reading", interested: true },
      { interestId: 2, interest: "Dancing or Singing", interested: false },
      { interestId: 3, interest: "Playing a musical instrument", interested: false },
      { interestId: 4, interest: "Sports or Games", interested: false },
      { interestId: 5, interest: "Creative writing", interested: false },
      { interestId: 6, interest: "Gardening", interested: false },
      { interestId: 7, interest: "Yoga", interested: false },
      { interestId: 8, interest: "Art", interested: false },
      { interestId: 9, interest: "Craft", interested: false },
      { interestId: 10, interest: "Cooking", interested: false },
      {
        interestId: 11,
        interest: "Regular chores at home with significant others (father, mother, guardian, sibling, etc.)",
        interested: false,
      }
    ],
  },
  partA2: {
    photoFamily: "path/to/family_photo.jpg",
    lstFriend: ["Alice", "Bob", "Charlie"],
    wantToBe: "Scientist",
    myFavourite: {
      color: "Blue",
      flower: "Rose",
      food: "Pizza",
      sport: "Cricket",
      animal: "Dog",
      subject: "Math",
    },
  },
  partB: {
    lstDomain: [
      {
        domainId: "D001",
        domain: "Physical Development",
        domainDesc: "Understanding advanced math concepts",
        lstGoals: ["Children develop habits that keep them healthy and safe."
          , "Children develop sharpness in sensorial perceptions."
          , "Children develop a fit and flexible body."],
        lstQuestion: [{ goal: "Learn algebra" }, { goal: "Master geometry" }],
        competency: "High",
        activityId: "A001",
        activity: "Solve equations",
        activityImg: "https://sms.cooledsys.com/sport.png",
        lstAssessmentQuestion: ["Solve for x", "Find the angle"],
        assessmentRubric: { a: 10, s: 20, c: 30 },
        observationalNotes: "Excellent problem solving skills. Excellent problem solving skills. Excellent problem solving skills. Excellent problem solving skills. Excellent problem solving skills. Excellent problem solving skills. Excellent problem solving skills. Excellent problem solving skills. Excellent problem solving skills. Excellent problem solving skills.",
        studentSelfAssessment: {
          like: 10,
          easy: 20,
          lstNeeded: [true, false, true, true, false],
        },
        peerAssessmentReceived: {
          like: "Yes",
          easy: "No",
          lstNeeded: [true, false, true, true, false],
        },
        peerAssessmentGiven: {
          like: "Yes",
          easy: "No",
          lstNeeded: [true, false, true, true, false],
        },
        parentObservation: {
          lstAvailable: [true, false, true, true, false],
          comment: "Needs more practice at home. Needs more practice at home. Needs more practice at home. Needs more practice at home. Needs more practice at home. Needs more practice at home. Needs more practice at home.",
        },
      },
    ],
  },
  partC: {
    lstPerformanceDescriptor: [
      {
        domainId: "D001",
        domain: "Physical Development",
        general: "Great improvement. Great improvement. Great improvement. Great improvement. Great improvement. Great improvement"
      },
      {
        domainId: "D002",
        domain: "Physical Development",
        general: "Great improvement. Great improvement. Great improvement. Great improvement. Great improvement. Great improvement"
      },
      {
        domainId: "D003",
        domain: "Physical Development",
        general: "Great improvement. Great improvement. Great improvement. Great improvement. Great improvement. Great improvement"
      },
      {
        domainId: "D004",
        domain: "Physical Development",
        general: "Great improvement. Great improvement. Great improvement. Great improvement. Great improvement. Great improvement"
      },
      {
        domainId: "D005",
        domain: "Physical Development",
        general: "Great improvement. Great improvement. Great improvement. Great improvement. Great improvement. Great improvement"
      },
      {
        domainId: "D006",
        domain: "Physical Development",
        general: "Great improvement. Great improvement. Great improvement. Great improvement. Great improvement. Great improvement"
      },
    ],
  },
};

var lstTmpStudentId = []
const HpcStudentTable = (props) => {
  const { openDiscountSlider,setStudentName, setImgPath, classId, classSectionId, setLoader, setOpacity, hpcFormat } = props;
  const [lstStudentId, setLstStudentId] = useState([]);
  const [lstFeesStudent, setLstFeesStudent] = useState([]);
  const [lstFeesStudents, setLstFeesStudents] = useState([]);
  const [filterstudent, setFilterstudent] = useState("");
  // const [studentName, setStudentName] = useState("")

  useEffect(() => {
    // console.log("feeStudentTable called");
    getLstFeeStudent(classId, classSectionId);
    setFilterstudent("");
  }, [classId, classSectionId]);

  const getLstFeeStudent = (clsId, clsSecId) => {
    // console.log("getLstFeeStudent called from feeStudentTable.js, classId", clsId, ", classSectionId", clsSecId);
    setLoader("block");
    setOpacity(0.5);
    getLstFeeStudentSvc(clsId, clsSecId, lstFeeStudentResponse);
  }

  const lstFeeStudentResponse = (data) => {
    var obj = data;
    if (obj.status === 'Success') {
      setLstFeesStudent(obj.lstFeeStudent);
      setLstFeesStudents(obj.lstFeeStudent);
    }
    else {
      if (obj.message == 'You are not logged in') {
        setTimeout(function () {
          window.location.href = "/";
        }, 2000);
        return false;
      }
      else if (obj.message == 'Your Session is expired, login again') {
        setTimeout(function () {
          window.location.href = "/";
        }, 2000);
        return false;
      } else {
        toast.error(obj.message);
      }
    }
    setLoader("none");
    setOpacity(1);
  }

  const filterFeeStudentTable = (fStudent) => {
    // console.log("filterFeeStudnetTable called");
    // console.log("lstFeeStudents", lstFeesStudents);
    // console.log("lstFeeStudent", lstFeesStudent);
    let filterFeeStudentList = [];
    filterFeeStudentList = lstFeesStudents.filter(feeStudent =>
      feeStudent.student.toString().toLowerCase().includes(fStudent.toLowerCase()));
    setLstFeesStudent(filterFeeStudentList);
  }

  const handleFilterStudent = (e) => {
    setFilterstudent(e.target.value);
    filterFeeStudentTable(e.target.value);
  }

  const selectAll = (e) => {
    var list_cbox = document.querySelectorAll('#hpcStudentBodyTable td input[type=checkbox]');
    list_cbox.forEach((cbox) => { if (cbox.checked !== e.target.checked) cbox.click(); })
  }

  function handleCboxChange(e, obj, status) {
    // console.log(obj, status)
    e.stopPropagation()
    if (status) {
      lstTmpStudentId.push(obj.studentId)
    }
    else {
      var idx = existsIn(obj.studentId, lstTmpStudentId);
      lstTmpStudentId.splice(idx, 1)
    }
    // console.log(lstTmpStudentId)
    props.setLstStudentId(lstTmpStudentId)
  }

  function existsIn(pStudentId, arr) {
    var idx = -1;
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === pStudentId) {
        idx = i;
        break;
      }
    }
    return idx;
  }
  const getHpc = (pLstStudentId) => {
    let acdYrId = localStorage.getItem("academicYearId")
    // console.log(localStorage.getItem("academicYearId"))
    // console.log(classId, classSectionId)
    let obj = { acdYrId: acdYrId, clsId: classId, sectionId: classSectionId, lstStudentId: pLstStudentId }
    // console.log(obj)
    getHpcListSvc(obj, cbHpcData)
  }
  const cbHpcData = (data) => {
    let obj = data;
    if (obj.status === 'Success') {
      // console.log(obj)
      obj.lstReportCard.forEach((newObj, idx) => {
        // console.log(newObj)
        newObj.partA1.lstInterestRender = []
        let ctr = 0;
        let tmpArr = []
        /* newObj.partA4.parentTeacherPartnership.lstSupportRender = []
        let ctr1 = 0;
        let tmpArr1 = []
        newObj.partA4.parentTeacherPartnership.lstNeedsSupport.forEach((item1, item1Idx) => {
          if ((item1Idx && item1Idx % 3 == 0 ) || item1Idx == newObj.partA4.parentTeacherPartnership.lstNeedsSupport.length - 1) {
            newObj.partA4.parentTeacherPartnership.lstSupportRender.push(tmpArr1)
            ctr1++;
            tmpArr1 = []
            // console.log(item1Idx,'=3 pushed',item1Idx == newObj.partA4.parentTeacherPartnership.lstNeedsSupport.length - 1, 'ctr=', ctr)
          } else {
            // console.log(item1Idx, '<3,ctr=', ctr1)
          }
          tmpArr1.push(item1)
        }) */
        newObj.partA1.lstInterest.forEach((item, itemIdx) => {
          if ((itemIdx && itemIdx % 3 == 0) || itemIdx == newObj.partA1.lstInterest.length - 1) {
            newObj.partA1.lstInterestRender.push(tmpArr)
            ctr++;
            tmpArr = []
            // console.log(itemIdx, '=3 pushed', itemIdx == newObj.partA1.lstInterest.length - 1, 'ctr=', ctr)
          } else {
            // console.log(itemIdx, '<3,ctr=', ctr)
          }
          tmpArr.push(item)
        })
        // console.log('lstInterestRender', newObj.partA1.lstInterestRender)
        // console.log('lstInterestRender', newObj.partA4.parentTeacherPartnership.lstSupportRender)
      })
      openDiscountSlider(obj)
    }
    else {
      if (obj.message == 'You are not logged in') {
        setTimeout(function () {
          window.location.href = "/";
        }, 2000);
        return false;
      }
      else if (obj.message == 'Your Session is expired, login again') {
        setTimeout(function () {
          window.location.href = "/";
        }, 2000);
        return false;
      } else {
        toast.error(obj.message);
      }
    }
    setLoader((prevLoader) => prevLoader - 1);
    setOpacity(1);
  }

  return (
    <div className="col-md-12">
      <table className="tableLayout1">
        <thead>
          <tr>
            <th style={{ width: 100 + 'px' }} colSpan='1'> Enrollment No. </th>
            <th style={{ width: 75 + 'px' }} colSpan='1'> Roll No. </th>
            <th style={{ width: 125 + 'px' }} colSpan='1'>
              <input type="text" className="form-control inp-search text-left"
                value={filterstudent}
                onChange={(e) => { handleFilterStudent(e) }}
                placeholder="Student"
              />
            </th>

            <th>Select
              <div>
                <input onChange={(e) => selectAll(e)} type="checkbox" id="cbxSelectAll" />
              </div>
            </th>
            <th style={{ width: 150 + 'px' }} rowSpan='2' colSpan='1'> Action </th>
          </tr>
        </thead>
      </table>
      <div
        className="hpcStudentTableDiv"
        style={{
          height: "400px",
          overflowY: "scroll",
          border: "1px solid #ccc",
        }}
      >
        <table id="hpcStudentTable" className="tableLayout">

          <tbody id="hpcStudentBodyTable">
            {lstFeesStudent && lstFeesStudent.map((students, i) => (
              <tr key={students.studentId} id={students.studentId}>
                <td style={{ width: 100 + 'px' }} className="text-left">{students.enrollmentNo}</td>
                <td style={{ width: 75 + 'px' }} className="text-center">{students.rollNo}</td>
                <td style={{ width: 125 + 'px' }} className="text-left">{students.student}</td>
                <td className='text-center' onClick={(e) => { e.stopPropagation(); e.target.firstChild.click() }}>
                  <input key={'trs_' + students.studentId}
                    id={'stud_' + students.studentId}
                    onClick={(e) => handleCboxChange(e, students, e.target.checked)}
                    type="checkbox"
                    defaultChecked={false}
                  />
                </td>

                <td style={{ width: 150 + 'px' }} className="text-center"
                >

                  <span className="glyphicon glyphicon-print"
                    title="Print" onClick={() => {
                      setStudentName(students.student)
                      setImgPath(students.imgPath)
                      //Fee Details
                      //print for single student
                      //call svc for single hpc print
                      if (hpcFormat == 10) {
                        getHpc([students.studentId])
                        // console.log('student,', students.studentId)
                      } else {
                        var data = {"status":"Success"
                          , "lstReportCard":[{
                          "schoolInfo": {
                            "school": "Sunrise Public School",
                            "address": "123 Elm Street",
                            "pin": "560001",
                            "udise": "123456789",
                            "apaarid": "APAARI005",
                            "teacherCode": "TCH001"
                          },
                          "partA1": {
                            "studentId": "S001",
                            "generalInfo": {
                              "student": "Priyansh Kumar",
                              "rollNo": "205",
                              "enrollmentNo": "ENR123",
                              "cls": "5",
                              "section": "A",
                              "dob": "2005-05-15",
                              "age": 10,
                              "address": "456 Maple Avenue, New Delhi",
                              "phone": "9876543210",
                              "photo": "path/to/photo.jpg",
                              "motherInfo": {
                                "parentId": "P001",
                                "parent": "Suman Kumari",
                                "education": "Graduate",
                                "occupation": "Teacher"
                              },
                              "fatherInfo": {
                                "parentId": "P002",
                                "parent": "Rajesh Kumar",
                                "education": "Postgraduate",
                                "occupation": "Engineer"
                              },
                              "guardianInfo": {
                                "parentId": "P003",
                                "parent": "Uncle Ramesh",
                                "education": "High School",
                                "occupation": "Farmer"
                              },
                              "noOfSiblings": 2,
                              "siblingsAge": [8, 12],
                              "motherTongue": "Hindi",
                              "instructionMedium": "English",
                              "flgRuralUrban": "Urban"
                            },
                            "attendanceInfo": {
                              "lstAttendance": [
                                { "monthId": 1, "month": "Apr", "workingDays": 22, "daysAttended": 20, "pctAttendance": "90%" },
                                { "monthId": 2, "month": "May", "workingDays": 20, "daysAttended": 18, "pctAttendance": "90%" },
                                { "monthId": 3, "month": "Jun", "workingDays": "", "daysAttended": "", "pctAttendance": "" },
                                { "monthId": 4, "month": "Jul", "workingDays": "", "daysAttended": "", "pctAttendance": "" },
                                { "monthId": 5, "month": "Aug", "workingDays": "", "daysAttended": "", "pctAttendance": "" },
                                { "monthId": 6, "month": "Sep", "workingDays": "", "daysAttended": "", "pctAttendance": "" },
                                { "monthId": 7, "month": "Oct", "workingDays": "", "daysAttended": "", "pctAttendance": "" },
                                { "monthId": 8, "month": "Nov", "workingDays": "", "daysAttended": "", "pctAttendance": "" },
                                { "monthId": 9, "month": "Dec", "workingDays": "", "daysAttended": "", "pctAttendance": "" },
                                { "monthId": 10, "month": "Jan", "workingDays": "", "daysAttended": "", "pctAttendance": "" },
                                { "monthId": 11, "month": "Feb", "workingDays": "", "daysAttended": "", "pctAttendance": "" },
                                { "monthId": 12, "month": "Mar", "workingDays": "", "daysAttended": "", "pctAttendance": "" }
                              ],
                              "lowAttendanceReason": "Medical reasons"
                            },
                            "lstInterest": [
                              { "interestId": 1, "interest": "Reading", "interested": true },
                              { "interestId": 2, "interest": "Dancing or Singing", "interested": false },
                              { "interestId": 3, "interest": "Playing a musical instrument", "interested": false },
                              { "interestId": 4, "interest": "Sports or Games", "interested": false },
                              { "interestId": 5, "interest": "Creative writing", "interested": false },
                              { "interestId": 6, "interest": "Gardening", "interested": false },
                              { "interestId": 7, "interest": "Yoga", "interested": false },
                              { "interestId": 8, "interest": "Art", "interested": false },
                              { "interestId": 9, "interest": "Craft", "interested": false },
                              { "interestId": 10, "interest": "Cooking", "interested": false },
                              { "interestId": 11, "interest": "Regular chores at home with significant others (father, mother, guardian, sibling, etc.)", "interested": false }
                            ]
                          },
                          "partA2": {
                            "aboutMe": {
                              "relative": "family",
                              "address": "C-90, Gali No. 6, Karim Nagar, Delhi",
                              "freeTime": "completing my homework and learning new words to enhance my German vocabulary",
                              "habit": "spending time making tea and cooking snacks",
                              "responsible": "sometimes",
                              "doBetterIn": "playing, singing, communicating",
                              "showCareBy": "paying gratitude towards them",
                              "feelProudWhen": "I achieve a top 5 position in the class"
                            },
                            "myGoalSetting": {
                              "personal": {
                                "whyGoal": "When I see foreign people, I feel like understanding them better and promoting India on the global stage",
                                "goalStep1": "I study topics of interest to foreign people like culture, history, and lifestyle",
                                "goalStep2": "I make an effort to converse with them on various topics to better understand them"
                              },
                              "academic": {
                                "whyGoal": "I want to improve my academic performance and raise my rank in class",
                                "goalStep1": "Study consistently, focusing on weaker subjects like Mathematics",
                                "goalStep2": "Utilize the internet for additional learning and practice"
                              }
                            },
                            "myLearning": {
                              "lstSchool": [
                                "Public Speaking",
                                "Problem-Solving",
                                "Technology & Coding",
                                "Teamwork & Collaboration"
                              ],
                              "lstOutside": [
                                "Sports & Physical Fitness",
                                "Volunteering/Community Service",
                                "Arts & Culture (Painting, Dance, Music)",
                                "Coding or Digital Literacy"]
                            },
                            "forMyTeacher": {
                              "helpMeWith": "study techniques and exam preparation",
                              "teacherToKnow": "about my interests in playing and drawing"
                            }
                          },
                          "partA3": {
                            "myAmbitionCard": {
                              "myAmbition": "Become a successful AI Engineer specializing in cutting- edge innovations.",
                              "lstSkillsNeeded": ["Machine Learning", "Deep Learning", "Critical Thinking", "Leadership"],
                              "achieveAmitionByDt": "2027-06-30",
                              "lstFocusSubjects": ["Mathematics", "Computer Science", "Physics"],
                              "studyHabits": ["Daily Practice", "Group Study", "Time Management"],
                              "iWill": {
                                "takeGuidanceFrom": "Mentor, Parents, Teachers",
                                "helpMeBy": "Providing resources, encouragement, and regular feedback",
                                "learnNew": "Advanced Programming, AI Concepts",
                                "iWillFeel": "Proud and Accomplished",
                                "myParentsWillFeel": "Happy and Proud"
                              }
                            }
                          },
                          "partA4": {
                            "parentTeacherPartnership": {
                              "lstResourcesAtHome": [10, 20, 30],
                              "childUnderstanding": {
                                "motivated": 10,
                                "schedule": 20,
                                "difficult": 40,
                                "progress": 30
                              },
                              "lstSupportRender": [],
                              "lstNeedsSupport": [
                                { "supportId": 1, "support": "Languages (R1, R2, R3)", "needed": true },
                                { "supportId": 2, "support": "Mathematics", "needed": true },
                                { "supportId": 3, "support": "Science", "needed": true },
                                { "supportId": 4, "support": "Social Science", "needed": true },
                                { "supportId": 5, "support": "Building self-belief and self-reliance", "needed": true },
                                { "supportId": 6, "support": "Developing social skills and conflict resolution", "needed": true },
                                { "supportId": 7, "support": "Managing difficult emotions like anger", "needed": true },
                                { "supportId": 8, "support": "Developing effective study skills like time management", "needed": true },
                                { "supportId": 9, "support": "Vocational Guide/Digital Literacy", "needed": true }
                              ],
                              "parentSupportRemarks": "Fostering a strong parent-teacher partnership is essential to ensure your child's holistic development. While teachers support at school, use this space to write how can you provide additional support to your child at home."
                            }
                          }
                        }]}
                        cbHpcData(data)
                      }

                    }}
                  ></span>




                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>

  );
}

export default HpcStudentTable;